import React, { useEffect, useState } from "react";

import { Button, Form, Modal } from "react-bootstrap";
import pagesActions from "../../pages/pagesActions";
import { Actions } from "../../../client/Actions";
import { useTranslation } from 'react-i18next';


const ManagementAction = ({
                            generatedId,
                            icon,
                            title,
                            actionName,
                            showModal,
                            setShowModal,
                            extended,
                            selectable,
                            description,
                            customApi,
                            loader,
                            setLoader,
                            onFinish,
                            props
                          }) => {

  const { t } = useTranslation();

  const [actionTools, setActionTools] = useState([]);
  const [actionMachines, setActionMachines] = useState([]);

  const [selectedActionTool, setSelectedActionTool] = useState();
  const [selectedActionMachine, setSelectedActionMachine] = useState();

  const updateDashboard = (props) => {
    if (selectable) {
      Actions.get("/admin/" + actionName + "Tool/", callbackActionTools);
      if (extended) {
        pagesActions.actionToolsSimple("machine", callbackActionMachines, actionName);
      }
    }
  };


  const handleSubmitAction = () => {
    setLoader(true);
    if (customApi) {
      customApi(callbackMakeAction);
    } else {
      Actions.post(`management/${actionName}/${generatedId}${selectedActionTool ? "/" + selectedActionTool : ""}${selectedActionMachine ? "/" + selectedActionMachine : ""}`,
        {},
        callbackMakeAction
      );
    }


  };

  const callbackActionTools = (resp) => {
    setActionTools(resp);
    setDefault(resp);
  };

  const callbackActionMachines = (resp) => {
    setActionMachines(resp);
    setDefaultMachine(resp);
  };

  const callbackMakeAction = (resp) => {
    setLoader(false);
    setShowModal(false);

    setShowSuccess(true);


    // if (resp.status === "NO_DEFAULT") {
    //   setShowNoDefault(true);
    // }
    //
    // if (resp.status === "ERROR") {
    //   // TODO some action
    // }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    if (onFinish) {
      onFinish();
    }
  };

  //success

  const [showSuccess, setShowSuccess] = useState(false);

  const handleCloseSuccess = () => {
    setShowSuccess(false);
    if (onFinish) {
      onFinish();

    }

    // window.location.reload();
  };

  //no default

  const [showNoDefault, setShowNoDefault] = useState(false);

  const handleCloseNoDefault = () => {
    setShowNoDefault(false);
  };


  function validateAT(value) {
    if (value && value != "none") {
      setSelectedActionTool(value);
    } else {
      setSelectedActionTool();
    }
  }


  function validateM(value) {
    if (value && value != "none") {
      setSelectedActionMachine(value);
    } else {
      setSelectedActionMachine();
    }
  }

  function setDefault(at) {
    const defaultAT = at.find(t => t.defaultValue);
    if (defaultAT) {
      setSelectedActionTool(defaultAT.id);
    }
  }


  function setDefaultMachine(m) {
    const defaultM = m.find(t => t.defaultValue);
    if (defaultM) {
      setSelectedActionMachine(defaultM.id);
    }
  }

  function isAMValid() {
    if (extended) {
      return selectedActionMachine;
    } else {
      return true;
    }
  }

  function isATValid() {
    if (selectable) {
      return selectedActionTool;
    } else {
      return true;
    }
  }

  useEffect(updateDashboard, []);


  function prepareDescription() {
    return <> {t("actions.confirm_action")} <strong>{title}</strong>?</>;
  }

  return (
    <div>
      <Modal show={showModal} onHide={handleCloseModal} size="md">
        <Modal.Header closeButton>
          <Modal.Title><i className={`fas ${icon}`} /> {title}</Modal.Title>
        </Modal.Header>
        {selectable && extended ?
          <Modal.Body>
            <Form>
              <Form.Group controlId="at_control">
                <Form.Label><strong>{t("common.machine")}</strong></Form.Label>

                <Form.Control as="select" name="m"
                              value={selectedActionMachine}
                              className={!selectedActionMachine ? "is-invalid" : "is-valid"}
                              onChange={e => validateM(e.target.value)}>
                  <option value="none">{t("forms.choose")}</option>
                  {
                    actionMachines.map((el => {
                      return <option key={el.id} value={el.id}>{el.name}</option>;
                    }))
                  }
                </Form.Control>
              </Form.Group>
            </Form>
          </Modal.Body> :
          ""}
        {selectable ?
          <Modal.Body>
            <Form>
              <Form.Group controlId="at_control">
                <Form.Label><strong>{t("actions.agent")}</strong></Form.Label>

                <Form.Control as="select" name="at"
                              value={selectedActionTool}
                              className={!selectedActionTool ? "is-invalid" : "is-valid"}
                              onChange={e => validateAT(e.target.value)}>
                  <option value="none">{t("forms.choose")}</option>
                  {
                    actionTools.map((el => {
                      return <option key={el.id} value={el.id}>{el.name}</option>;
                    }))
                  }
                </Form.Control>
              </Form.Group>
            </Form>
          </Modal.Body> :
          <Modal.Body>{description ||  prepareDescription() }</Modal.Body>
        }
        <Modal.Footer>
          <Button variant="light" onClick={handleCloseModal}>{t("common.cancel")}</Button>
          <Button variant="primary" disabled={!(isATValid() && isAMValid())}
                  className="Modal_btn_submit" onClick={handleSubmitAction}>{t("common.confirm")}</Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showSuccess} onHide={handleCloseSuccess} size="md">
        <Modal.Header closeButton>
          <Modal.Title><i className={`fas ${icon}`} /> {t("forms.success")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{t("actions.action_successful")} <strong>{title}</strong>.</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" className="Modal_btn_submit" onClick={handleCloseSuccess}>{t("common.continue")}</Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showNoDefault} onHide={handleCloseNoDefault} size="md">
        <Modal.Header closeButton>
          <Modal.Title><i className={`fas ${icon}`} /> {t("actions.cannot_execute_action")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{`${t("actions.no_selected_agent_or_machine")}${extended ? t("actions.or_machine") : ""}${t("actions.in_admin_panel_for_action")}`}
          <strong>{title}</strong>.</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" className="Modal_btn_submit" onClick={handleCloseNoDefault}>{t("common.continue")}</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}



export default ManagementAction;
